/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryHook} from '../types'
import {getCompositePrice} from '../api'

 export const useQueryGetCompositePrice = createReactQueryHook('getCompositePrice', getCompositePrice)
